<template>
  <Modal :show="show" :auto-close="false">
    <Toolbar class="ehsdialog-header"> {{ headerTitle }} </Toolbar>
    <div class="ehsdialog-content">
      <slot></slot>
    </div>
    <Toolbar class="ehsdialog-footer">
      <Button color="primary" @click="primaryActionFunction" class="mr-2">
        {{ primaryButtonText }}
      </Button>
      <Button v-show="hasSecondaryAction" color="secondary" @click="secondaryActionFunction">
        {{ secondaryButtonText }}
      </Button>
    </Toolbar>
  </Modal>
</template>

<script>
import Modal from '@wizer/core/components/modal/Modal'
import Toolbar from '@wizer/core/components/toolbar/Toolbar'
import Button from '@wizer/core/components/button/Button'

export default {
  name: 'EHS360Modal',
  components: {
    Modal,
    Toolbar,
    Button,
  },
  props: {
    headerTitle: String,
    primaryButtonText: String,
    secondaryButtonText: String,
    hasSecondaryAction: {
      type: Boolean,
      default: false,
    },
    primaryActionFunction: {
      type: Function,
      default: () => {
        this.$emit('primaryButtonClick')
        this.show = false
      },
    },
    secondaryActionFunction: {
      type: Function,
      default: () => {
        this.$emit('secondaryButtonClick')
        this.show = false
      },
    },
  },
  data() {
    return {
      show: true,
    }
  },
}
</script>

<style scoped>
.ehsdialog-content {
  @apply py-5;
}
.ehsdialog-header {
  @apply h-12;
  @apply border-b border-gray-300;
  @apply font-bold text-gray-800 tracking-wide;
}
.ehsdialog-footer {
  @apply self-end h-12;
  @apply border-t border-gray-300;
  @apply px-4;
}
</style>
